export default __webpack_public_path__ + "static/media/btn-color-de_de@2x.14ae2a15.png";